import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { countries } from '../utils/countries';

const CountrySelect = ({
  value,
  onChange,
  variant = 'filled',
  sx = {},
  fullWidth = true,
  label = 'Country',
  name = 'country',
  required = false,
  error = false,
  helperText = '',
  disabled = false
}) => {
  // Find the country object from the value (which is the country name)
  const selectedCountry = countries.find(c => c.name === value) || null;
  
  const handleChange = (_, newValue) => {
    // Create a synthetic event object similar to regular input onChange
    const syntheticEvent = {
      target: {
        name: name,
        value: newValue ? newValue.name : ''
      }
    };
    onChange(syntheticEvent);
  };

  return (
    <Autocomplete
      id={name}
      options={countries}
      getOptionLabel={(option) => option.name}
      value={selectedCountry}
      onChange={handleChange}
      disabled={disabled}
      fullWidth={fullWidth}
      sx={sx}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant={variant}
          required={required}
          error={error}
          helperText={helperText}
          name={name}
        />
      )}
      isOptionEqualToValue={(option, value) => option.name === value?.name}
      clearOnBlur
      selectOnFocus
      handleHomeEndKeys
      blurOnSelect
    />
  );
};

export default CountrySelect;